import { RequestConfirmationCodeResponse } from '../../../../types/requests';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { TWO_FACTOR_BASE_PATH } from '../constants/twoFactorBasePath';

export const postRequestConfirmationCode = (
  constructPost: ConstructPost,
  data: Record<string, unknown>,
): Promise<NonPaginatedResponse<RequestConfirmationCodeResponse> | undefined> =>
  constructPost<NonPaginatedResponse<RequestConfirmationCodeResponse>>(
    `${TWO_FACTOR_BASE_PATH}/request-confirmation-code`,
    { data },
    { preventDefaultErrorToast: true },
  );
